<template>
  <div class="row">
    <div
      v-if="showCard === true"
      class="col-md-6 cards"
      :class="cardStatus == 'Suspended' ? 'red' : ''"
    >
      <div class="cardNo">**** **** **** {{ last4Digits }}</div>
      <div class="cardExp">Expiry date: {{ expiry }}</div>
      <div class="acctNoTitle">Account Number</div>
      <div class="acctNo">{{ id }}</div>
      <div class="acctDisplay">
        <a title="Reveal PIN" v-on:click="loadCardPin">Reveal PIN</a>
      </div>
      <div class="freeze">
        <a data-toggle="modal" data-target="#freezeConfirm"
          ><i class="far fa-snowflake"></i><span>Freeze</span></a
        >
      </div>
    </div>
    <div v-if="showMyVehicle === true" class="col-md-6 roundedFrame">
      <span class="vehicleTitle">My Vehicle: {{ vehicleName }}</span>
      <router-link v-bind:to="myVehicle">
        <a class="edit"><i class="fas fa-pen"></i></a>
      </router-link>
      <div class="row">
        <div class="col-md-6">
          <ul>
            <li>
              <span class="vehLabel">Dealer Tel: </span
              ><span>{{ dealerPhone }}</span>
            </li>
            <li>
              <span class="vehLabel">B/down Tel: </span
              ><span>{{ bDownPhone }}</span>
            </li>
            <li>
              <span class="vehLabel">Reg No: </span
              ><span>{{ registrationNumber }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <ul>
            <li>
              <span class="vehLabel">Tyre Pressure F: </span
              ><span>{{ tyrePressureF }}</span>
            </li>
            <li>
              <span class="vehLabel">Tyre Pressure R: </span
              ><span>{{ tyrePressureR }}</span>
            </li>
            <li>
              <span class="vehLabel">Oil Type: </span><span>{{ oilType }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      v-if="showCard === true"
      class="modal fade"
      id="freezeConfirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p>
              Freezing your card, suspends it from use<br />immediately so that
              it cannot be used.<br />You can reverse this at any time
            </p>
            <a
              ><button
                v-if="isFreezeCardButtonLoading === true"
                data-dismiss="modal"
                v-on:click="freezeCard"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Freezing card...
              </button>
              <button
                v-if="isFreezeCardButtonLoading === false"
                data-dismiss="modal"
                v-on:click="freezeCard"
              >
                Confirm and freeze my card now
              </button></a
            >
            <a><button data-dismiss="modal" class="white">Cancel</button></a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showCard === true"
      class="modal fade"
      id="changePinMessage"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      v-on:click="closeDisplayPinModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            v-on:click="closeDisplayPinModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="my-1">Your PIN number is</div>
            <div class="my-1">
              {{ cardPin }}
            </div>
            <div class="my-2">
              You must keep your PIN safe and secure. Do not write your PIN
              number down.
            </div>
            <div class="my-1">
              For your security this message will be hidden after 25 seconds
            </div>
            <div
              class="my-1 pt-1 pr-2 pb-4 pl-2"
              style="background-color: black; margin-left: -7px; margin-right: -7px;"
            >
              Should you wish to change your PIN this can be done at the
              majority of bank ATM machines
            </div>
            <!-- <a>
              <button
                data-toggle="modal"
                data-target="#setNewPinModal"
                v-on:click="showSetNewPinModale"
              >
                Change PIN
              </button>
            </a> -->
            <a
              ><button
                data-dismiss="modal"
                class="white"
                v-on:click="closeDisplayPinModal"
              >
                Cancel
              </button></a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      v-if="showCard === true"
      class="modal fade"
      id="setNewPinModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <div class="my-1">Set new PIN</div>
            <div class="my-1">
              <input
                type="text"
                maxlength="4"
                placeholder="New Pin"
                v-model="newPin"
              />
            </div>
            <div class="my-2">
              You must keep your PIN safe and secure. Do not write your PIN
              number down.
            </div>
            <a>
              <button v-on:click="setNewPin">Confirm new PIN</button>
            </a>
            <a><button data-dismiss="modal" class="white">Cancel</button></a>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      v-if="showCard === true"
      class="modal fade"
      id="confirmSetNewPinModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      v-on:click="closeConfirmSetNewPinModale"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            v-on:click="closeConfirmSetNewPinModale"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p>
              <strong
                >Pass code sent to your phone number<br />registered for this
                card vis SMS</strong
              >
            </p>
            <p>
              Registered Phone number<br /><span class="regNo"
                ><strong>xxxxxxx{{ lastFourPhoneDigits }}</strong></span
              >
            </p>

            <div class="loginControls regNo">
              <form action="form" @submit.prevent="confirmSetNewPin">
                <input
                  type="text"
                  maxlength="1"
                  id="digit1SetNewPin"
                  name="digit1"
                  v-model="digit1"
                  @keypress="onlyNumber"
                />
                <input
                  type="text"
                  maxlength="1"
                  id="digit2SetNewPin"
                  name="digit2"
                  v-model="digit2"
                  @keypress="onlyNumber"
                />
                <input
                  type="text"
                  maxlength="1"
                  id="digit3SetNewPin"
                  name="digit3"
                  v-model="digit3"
                  @keypress="onlyNumber"
                />
                <input
                  type="text"
                  maxlength="1"
                  id="digit4SetNewPin"
                  name="digit4"
                  v-model="digit4"
                  @keypress="onlyNumber"
                />
                <input
                  type="text"
                  maxlength="1"
                  id="digit5SetNewPin"
                  name="digit5"
                  v-model="digit5"
                  @keypress="onlyNumber"
                />
                <input
                  type="text"
                  maxlength="1"
                  id="digit6SetNewPin"
                  name="digit6"
                  v-model="digit6"
                  @keypress="onlyNumber"
                />

                <p class="remaining">
                  If you couldn't receive the SMS within 5 minutes you can try
                  again
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import routes from "@/constants/routes";
import actions from "@/store/cards/actions";

export default {
  created() {
    this.myVehicle = routes.MYVEHICLE;
    this.showCard =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showCard === true);
    this.showMyVehicle =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showMyVehicle === true);
  },
  data: () => ({
    newPin: "",
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: ""
  }),
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    isActiveFreezeCardModale: {
      get() {
        return this.$store.state.settings.isActiveFreezeCardModale;
      },
      set(value) {
        this.$store.commit("updateIsDisplayFreezeCardActiveMutation", value);
      }
    },
    isActiveDisplayChangePINModale: {
      get() {
        return this.$store.state.settings.isActiveDisplayChangePINModale;
      },
      set(value) {
        this.$store.commit("updateIsDisplayChangePINActiveMutation", value);
      }
    },
    isActiveSetNewPinModale: {
      get() {
        return this.$store.state.settings.isActiveSetNewPinModale;
      },
      set(value) {
        this.$store.commit("updateIsActiveSetNewPinModaleMutation", value);
      }
    },
    cardGuid: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.cardGuid;
      }
    },
    cardPin: {
      get() {
        return this.$store.state.cards.cardPin;
      }
    },
    last4Digits: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.card?.last4Digits;
      }
    },
    lastFourPhoneDigits: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.phone.slice(
          this.$store.state.accounts.fullAccountDetails.user?.phone.length - 4
        );
      }
    },
    expiry: {
      get() {
        const month =
          new Date(
            this.$store.state.accounts.fullAccountDetails.card?.expiry
          ).getMonth() + 1;
        const year = new Date(
          this.$store.state.accounts.fullAccountDetails.card?.expiry
        ).getFullYear();
        return month < 10 ? `0${month}/${year}` : `${month}/${year}`;
      }
    },
    id: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.card?.id;
      }
    },
    vehicleName: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle?.name;
      }
    },
    dealerPhone: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle
          ?.dealerPhone;
      }
    },
    bDownPhone: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle
          ?.bDownPhone;
      }
    },
    registrationNumber: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle
          ?.registrationNumber;
      }
    },
    tyrePressureF: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle
          ?.tyrePressureF;
      }
    },
    tyrePressureR: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle
          ?.tyrePressureR;
      }
    },
    oilType: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.vehicle?.oilType;
      }
    },
    cardStatus: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.card?.status;
      }
    },
    isFreezeCardButtonLoading: {
      get() {
        return this.$store.state.settings.isFreezeCardButtonLoading;
      },
      set(value) {
        this.$store.commit("updateIsFreezeCardButtonLoadingMutation", value);
      }
    },
    isDisplayPinModaleActive: {
      get() {
        return this.$store.state.settings.isDisplayPinModaleActive;
      },
      set(value) {
        this.$store.commit("updateIsDisplayPinModaleActiveMutation", value);
      }
    },
    isActiveConfirmSetNewPinModale: {
      get() {
        return this.$store.state.settings.isActiveConfirmSetNewPinModale;
      },
      set(value) {
        this.$store.commit(
          "updateIsActiveConfirmSetNewPinModaleMutation",
          value
        );
      }
    }
  },
  methods: {
    freezeCard: async function() {
      this.isFreezeCardButtonLoading = true;
      await this.$store.dispatch(
        actions.PUT_CARD_STATUS_AS_FROZEN,
        this.cardGuid
      );
    },
    showSetNewPinModale: async function() {
      this.isActiveDisplayChangePINModale = false;
      this.isActiveSetNewPinModale = true;
      window.$("#changePinMessage").modal("hide");
    },
    loadCardPin: async function() {
      await this.$store.dispatch(actions.FETCH_CARD_PIN, this.cardGuid);
    },
    closeDisplayPinModal: function() {
      this.isDisplayPinModaleActive = false;
    },
    closeConfirmSetNewPinModale: function() {
      this.isActiveConfirmSetNewPinModale = false;
    },
    onlyNumber: function($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const symbol = String.fromCharCode(keyCode);

      if (/^\s*$/.test(symbol) || isNaN(symbol)) {
        $event.preventDefault();
      } else {
        const inputId = $event.target.id;

        switch (inputId) {
          case "digit1SetNewPin":
            this.digit1 = symbol;
            break;
          case "digit2SetNewPin":
            this.digit2 = symbol;
            break;
          case "digit3SetNewPin":
            this.digit3 = symbol;
            break;
          case "digit4SetNewPin":
            this.digit4 = symbol;
            break;
          case "digit5SetNewPin":
            this.digit5 = symbol;
            break;
          case "digit6SetNewPin":
            this.digit6 = symbol;
            break;
          default:
            break;
        }

        $event.preventDefault();
        this.confirmSetNewPin();
        $event.target.nextElementSibling.focus();
      }
    },
    setNewPin: async function() {
      // if (isNaN(this.newPin)) { TODO: implement PIN validation
      window.$("#setNewPinModal").modal("hide");
      const payload = {
        newPin: this.newPin
      };
      await this.$store.dispatch(actions.PUT_NEW_CARD_PIN, payload);
      this.newPin = "";
    },
    confirmSetNewPin: async function() {
      if (
        this.digit1 !== "" &&
        this.digit2 !== "" &&
        this.digit3 !== "" &&
        this.digit4 !== "" &&
        this.digit5 !== "" &&
        this.digit6 !== ""
      ) {
        const confirmationSmsCode = `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`;
        const confirmSetNewPinPayload = {
          cardGuid: this.cardGuid,
          code: confirmationSmsCode
        };
        this.$store.dispatch(
          actions.PUT_CONFIRM_CODE_TO_SET_NEW_CARD_PIN,
          confirmSetNewPinPayload
        );
        window.$("#confirmSetNewPinModal").modal("hide");
        this.digit1 = "";
        this.digit2 = "";
        this.digit3 = "";
        this.digit4 = "";
        this.digit5 = "";
        this.digit6 = "";

        this.closeConfirmSetNewPinModale();
      }
    }
  },
  watch: {
    isDisplayPinModaleActive: function() {
      if (this.isDisplayPinModaleActive) {
        window.$("#changePinMessage").modal("show");
      }
    },
    isActiveConfirmSetNewPinModale: function() {
      if (this.isActiveConfirmSetNewPinModale) {
        window.$("#confirmSetNewPinModal").modal("show");
      }
    }
  }
};
</script>
